import BaseModel from 'models/base-model';
import { AUTO_TIEOUT_COMPARE_MODE_FAILED } from 'constants/feature/statement-content-constants';

export default class SideBySideViewMode extends BaseModel({
  sideBySideViewMode: '',
  autoTieoutStatusForBanner: '', // to show/hide auto tieout banner based on the status of auto tieout process do not use it for workflow status
  showRetry: false, // default value is false, we dont want to show retry option when stale falg is true and import/trial balance API failed. THis flag is for handling that scenario
}) {
  get viewMode() {
    return this.sideBySideViewMode;
  }

  setAutoTieoutStatusForBanners({ status, show = true }) {
    return this.merge({
      autoTieoutStatusForBanner: status,
      showRetry: status === AUTO_TIEOUT_COMPARE_MODE_FAILED ? show : false,
    });
  }

  getAutoTieoutStatusForBanner() {
    return this.autoTieoutStatusForBanner;
  }

  setViewMode(val) {
    return this.merge({
      sideBySideViewMode: val,
    });
  }
}
